import React from 'react';
import { Container, Row } from 'reactstrap';
import FinancialReportStepsTwoAutomaticIncomeForm from './FinancialReportStepsTwoAutomaticIncomeForm';

const FinancialReportStepsTwoAutomaticIncome = () => {
  return (
    <Container>
      <Row>
        <FinancialReportStepsTwoAutomaticIncomeForm />
      </Row>
    </Container>
  );
};

export default FinancialReportStepsTwoAutomaticIncome;